<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    activeKey="maintenance-regime"
                    variableWidth
                    :data="tabs">
                    <template slot="gofixTab:maintenance-regime">
                        <gofix-card title="" class="pt-4" classContent="mb-0" v-bind:class="{'run-loading': headerEntry.options.loadings.table}">
                            <b-col md="12">
                                <b-row>
                                    <b-col md="3">
                                        <b-row>
                                            <b-col md="6">
                                                <gofix-form-dropdown
                                                    label="Month"
                                                    :clearable="false"
                                                    :filterable="true"
                                                    :searchable="true"
                                                    :reduce="option => option['value']"
                                                    fullContent
                                                    :options="headerEntry.options.months"
                                                    v-model="headerEntry.data.month">
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="6">
                                                <gofix-form-dropdown
                                                    label="Year"
                                                    :clearable="false"
                                                    :filterable="true"
                                                    :searchable="true"
                                                    :options="headerEntry.options.years"
                                                    v-model="headerEntry.data.year">
                                                </gofix-form-dropdown>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col md="5">
                                        <b-row>
                                            <b-col md="6">
                                                <gofix-form-dropdown
                                                    v-bind:class="{'run-loading small-loading': loading}"
                                                    label="Supplier Contract"
                                                    vLabel="contract_title"
                                                    :reduce="option => option['id']"
                                                    :clearable="false"
                                                    :filterable="true"
                                                    :searchable="true"
                                                    v-model="headerEntry.data.contract_id"
                                                    :options="headerEntry.options.supplier_contracts">
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="6">
                                                <gofix-form-dropdown
                                                    v-bind:class="{'run-loading small-loading': loading}"
                                                    label="Maintenance Type"
                                                    vLabel="description_one"
                                                    :clearable="false"
                                                    :filterable="true"
                                                    :searchable="true"
                                                    :reduce="option => option['id']"
                                                    v-model="headerEntry.data.maintenance_id"
                                                    :options="headerEntry.options.maintenances">
                                                </gofix-form-dropdown>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col md="4">
                                        <b-row>
                                            <b-col md="6" class="text-right pt-15">
                                                
                                            </b-col>
                                            <b-col md="6" class="text-left pt-15">
                                                
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </gofix-card>
                        <gofix-card fullContent class="mb-0" classContent="dataEntryTable" v-show="headerEntry.data.items.length" v-bind:class="{'run-loading': headerEntry.options.loadings.table}">
                            <gofix-table :settings="tableConfig"
                                    :table-items="tableItems"
                                    @load-items="getTableData"
                                    @row-click="openModalEdit"
                                    ref="gofixTable">
                                <template slot="gofix_table:planned_schedule" slot-scope="row">
                                    <span class="fakeInput">{{row.item.planned_schedule || 0}}</span>
                                </template>
                                <template slot="gofix_table:completed_schedule" slot-scope="row">
                                    <span class="fakeInput">{{row.item.completed_schedule || 0}}</span>
                                </template>
                                <template slot="gofix_table:incompleted_schedule" slot-scope="row">
                                    {{row.item.incompleted_schedule || 0}}
                                </template>
                                <template slot="gofix_table:planned_schedule_percent" slot-scope="row">
                                    {{row.item.planned_schedule_percent || 0}}%
                                </template>
                                <template slot="gofix_table:completed_schedule_percent" slot-scope="row">
                                    {{row.item.completed_schedule_percent || 0}}%
                                </template>
                                <template slot="gofix_table:incompleted_schedule_percent" slot-scope="row">
                                    {{row.item.incompleted_schedule_percent || 0}}%
                                </template>
                                <template slot="gofix_table:bottom-row" slot-scope="row" v-if="tableItems.length">
                                    <td class="text-right" :key="i" v-for="(field, i) in row.data.fields">
                                        <div class="total-header" v-if="field.key === 'property_name'">
                                            <p class="mb-1 text-left">
                                                <strong>Total/Average</strong>
                                            </p>
                                        </div>
                                        <div v-if="field.key === 'planned_schedule'">
                                            <p class="mb-1 text-center">{{ totalItems.planned_schedule }}</p>
                                        </div>
                                        <div v-if="field.key === 'completed_schedule'">
                                            <p class="mb-1 text-center">{{ totalItems.completed_schedule }}</p>
                                        </div>
                                        <div v-if="field.key === 'incompleted_schedule'">
                                            <p class="mb-1 text-center">{{ totalItems.incompleted_schedule }}</p>
                                        </div>
                                        <div v-if="field.key === 'planned_schedule_percent'">
                                            <p class="mb-1 text-center">{{ totalItems.planned_schedule_percent }}%</p>
                                        </div>
                                        <div v-if="field.key === 'completed_schedule_percent'">
                                            <p class="mb-1 text-center">{{ totalItems.completed_schedule_percent }}%</p>
                                        </div>
                                        <div v-if="field.key === 'incompleted_schedule_percent'">
                                            <p class="mb-1 text-center">{{ totalItems.incompleted_schedule_percent }}%</p>
                                        </div>
                                    </td>
                                </template>
                            </gofix-table>
                            <div class="p-2"><gofix-button label="Save" @click="saveDataEntry" :loading="headerEntry.options.loading"></gofix-button></div>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal
                :no-close-on-backdrop="true"
                id="modal-Create"
                :title="modals.edit.title"
                hide-footer
                :centered="true"
                v-model="modals.edit.open">
            <div class="" v-bind:class="{'run-loading':modals.edit.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-input-number
                                label="Planned Schedule (No)"
                                thousandsSeparatorSymbol=""
                                :includeThousandsSeparator="false"
                                v-model="modals.edit.data.planned_schedule"
                                required />
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input-number
                                label="Completed Schedule (No)"
                                thousandsSeparatorSymbol=""
                                :includeThousandsSeparator="false"
                                v-model="modals.edit.data.completed_schedule"
                                required />
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="text-right d-block">
                    <gofix-button label="Submit" @click="saveDrafDataEntry" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.comfirmReload.open">
            <div class="center">Do you want to reload data entries?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.comfirmReload.open = false">Cancel</b-button>
                <b-button class="custom-btn" :disabled="modals.comfirmReload.loading" @click="reloadDataEntries"> <b-spinner v-if="modals.comfirmReload.loading" small type="grow"></b-spinner> Reload</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'pa-data-entries-maintenance-regime',
        data() {
            return {
                tabs: tabData.performance_assesment_data_entries,
                loading: false,
                tableConfig:{
                    name:' data-entry-mr',
                    controls:{
                        create: false,
                        update: false,
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false,
                        tablePagination: false,
                        reload: false,
                        tableFilter: false,
                    },
                    filter: {},
                    page: 1,
                    limit: -1,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                    fields: [
                        {
                            key: 'property_name',
                            label: 'Division',
                            isActive: 1,
                            isFilter: false,
                            thStyle : "width:300px",
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'planned_schedule',
                            label: 'Planned Schedule (No)',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            thStyle : "width:150px",
                        },
                        {
                            key: 'completed_schedule',
                            label: 'Completed Schedule (No)',
                            isActive: 1,
                            isFilter: false,
                            thStyle : "width:150px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'incompleted_schedule',
                            label: 'Incompleted Schedule (No)',
                            isActive: 1,
                            isFilter: false,
                            thStyle : "width:150px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'planned_schedule_percent',
                            label: 'Planned Schedule (%)',
                            isActive: 1,
                            isFilter: false,
                            thStyle : "width:150px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'completed_schedule_percent',
                            label: 'Completed Schedule (%)',
                            isActive: 1,
                            isFilter: false,
                            thStyle : "width:150px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'incompleted_schedule_percent',
                            label: 'Incompleted Schedule (%)',
                            isActive: 1,
                            isFilter: false,
                            thStyle : "width:150px",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'column_fix_with',
                            label: '',
                            isActive: 1,
                            isFilter: false,
                            thStyle : "",
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        }
                    ]
                },
                tableItems: [],
                supplier_contracts: [],
                maintenance_ids: [],
                modals: {
                    edit : {
                        open: false,
                        loading: false,
                        title: "Edit Division",
                        data: {
                            planned_schedule: 0,
                            completed_schedule: 0,
                            index: 0
                        },
                    },
                    comfirmReload: {
                        open:false,
                        loading: false,
                        data: []
                    }
                },
                headerEntry: {
                    options: {
                        maintenances: [],
                        supplier_contracts: [],
                        years:[],
                        months:[],
                        changed: false,
                        loadings:{
                            table:false,
                            button:false,
                            header:false,
                        },
                    },
                    data: {
                        month: null,
                        year: null,
                        contract_id: null,
                        contract_name: null,
                        maintenance_id: null,
                        maintenance_name: null,
                        type:'maintenance regime',
                        items: []
                    }
                },
            }
        },
        watch: {
            ClientContractID: function(val) {
                this.getSupplierContract()
            },
            "headerEntry.data.contract_id" : function(val){
                if(val){
                    this.getMaintenanceType()
                }
            },
            "headerEntry.data.year" : function(val){
                if(val && this.headerEntry.data.maintenance_id && this.headerEntry.data.month){
                    this.loadDataEntries()
                }
            },
            "headerEntry.data.month" : function(val){
                if(val && this.headerEntry.data.maintenance_id && this.headerEntry.data.year){
                    this.loadDataEntries()
                }
            },
            "headerEntry.data.maintenance_id" : function(val){
                if(val){
                    this.loadDataEntries()
                }else{
                    this.headerEntry.data.items = [];
                }

            },
            "headerEntry.data.items" : function(val){
                this.$refs.gofixTable.reloadTableItems()
            },
        },
        computed: {
            totalItems() {
                let data = {
                    planned_schedule : 0,
                    completed_schedule : 0,
                    incompleted_schedule : 0,
                    planned_schedule_percent : 0,
                    completed_schedule_percent : 0,
                    incompleted_schedule_percent : 0,
                }
                if(this.headerEntry.data.items.length){
                    for(let i = 0; i < this.headerEntry.data.items.length; i++){
                        let item = this.headerEntry.data.items[i];
                        data.planned_schedule += parseInt(item.planned_schedule) || 0
                        data.completed_schedule += parseInt(item.completed_schedule) || 0
                    }
                }
                data.incompleted_schedule = data.planned_schedule - data.completed_schedule
                data.planned_schedule_percent = 100
                data.completed_schedule_percent = data.planned_schedule ? (data.completed_schedule/data.planned_schedule * 100).toFixed(2) : 0
                data.incompleted_schedule_percent = data.planned_schedule ? (100 - data.completed_schedule_percent).toFixed(2) : 0

                return data
            },
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        created() {
            this.getInitData()
            this.getSupplierContract()
        },
        methods: {
            getInitData(){
                //Year options
                let nowYear = parseInt(moment().format('YYYY'));
                for(let i = nowYear;i >= nowYear - 15;i--){
                    this.headerEntry.options.years.push(i);
                }

                //Month Options
                this.headerEntry.options.months = [
                    {
                        label: "January",
                        value : 1,
                    },
                    {
                        label: "February",
                        value : 2,
                    },
                    {
                        label: "March",
                        value : 3,
                    },
                    {
                        label: "April",
                        value : 4,
                    },
                    {
                        label: "May",
                        value : 5,
                    },
                    {
                        label: "June",
                        value : 6,
                    },
                    {
                        label: "July",
                        value : 7,
                    },
                    {
                        label: "August",
                        value : 8,
                    },
                    {
                        label: "September",
                        value : 9,
                    },
                    {
                        label: "October",
                        value : 10,
                    },
                    {
                        label: "November",
                        value : 11,
                    },
                    {
                        label: "December",
                        value : 12,
                    },
                ];

                this.headerEntry.data.month = parseInt(moment().format('M'))
                this.headerEntry.data.year = parseInt(moment().format('YYYY'))
            },
            getSupplierContract(){
                this.loading = true
                let tableRequest = {
                    filter: {
                        contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : -1
                    },
                    limit: -1,
                    page: 1,
                    isCMS: 1,
                    useDatabaseView: true,
                    sortColumn: "contract_title",
                    sortDirection: "ASC"
                }
                this.$store.dispatch("ContractController/getListSContracts", tableRequest)
                    .then(response => {
                        this.headerEntry.options.supplier_contracts = response.data.data.contracts
                        this.headerEntry.data.contract_id = null
                        this.headerEntry.options.maintenances = []
                        this.headerEntry.data.maintenance_id = null

                        if(response.data.data.contracts[0].id){
                            this.headerEntry.data.contract_id = response.data.data.contracts[0].id
                        }

                        this.loading = false
                    })
                    .catch(err => {
                        this.loading = false
                    })
            },
            getMaintenanceType() {
                this.headerEntry.data.maintenance_id = null;
                let tableRequest = {
                        maintenance_type: "aes",
                        supplier_contract_id: this.headerEntry.data.contract_id,
                }
                this.$store.dispatch("PAConservancyController/getMaintenanceType", tableRequest)
                    .then(response => {
                        this.headerEntry.options.maintenances = response
                    })
                    .catch(err => {
                        if(err.response.data.error.message.error) {
                            return  this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                        this.$alertNotification("Error", "danger");
                    })
            },
            async loadDataEntries() {
                if (this.headerEntry.options.loadings.table) return ;
                this.headerEntry.options.loadings.table = true
                let tableRequest = {
                    year: this.headerEntry.data.year,
                    month: this.headerEntry.data.month,
                    maintenance_id: this.headerEntry.data.maintenance_id,
                    supplier_contract_id: this.headerEntry.data.contract_id,
                    type: this.headerEntry.data.type
                }
                await this.$store.dispatch("PAConservancyController/loadDataEntries", tableRequest)
                    .then(response => {
                        if(this.headerEntry.options.changed && !response.is_new){
                            this.modals.comfirmReload.data = response.items
                            this.modals.comfirmReload.open = true
                        }else{
                            this.headerEntry.data.items = response.items
                        }
                        this.headerEntry.options.loadings.table = false
                    })
                    .catch(err => {
                        this.headerEntry.options.loadings.table = false
                        this.headerEntry.data.items = []
                        if(error.response.data.error.message.error) {
                            return  this.$alertNotification(error.response.data.error.message.error, "danger");
                        }
                        this.$alertNotification("Error", "danger");
                    })
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                const response = {
                    items: this.headerEntry.data.items,
                    total: this.headerEntry.data.items.length
                }
                this.tableItems = this.headerEntry.data.items
                resolve(response);
            },
            openModalEdit(item,index){
                this.modals.edit.title = item.property_name;
                this.modals.edit.data.planned_schedule = item.planned_schedule || 0
                this.modals.edit.data.completed_schedule = item.completed_schedule || 0
                this.modals.edit.data.index = index
                this.modals.edit.open = true
            },
            reloadDataEntries(){
                this.headerEntry.data.items = this.modals.comfirmReload.data
                this.modals.comfirmReload.open = false
                this.headerEntry.options.loadings.table = false
            },
            saveDrafDataEntry(){
                let index = this.modals.edit.data.index
                let planned_schedule = parseInt(this.modals.edit.data.planned_schedule)
                let completed_schedule = parseInt(this.modals.edit.data.completed_schedule)
                this.headerEntry.data.items[index].planned_schedule = planned_schedule
                this.headerEntry.data.items[index].completed_schedule = completed_schedule
                this.headerEntry.data.items[index].incompleted_schedule = planned_schedule - completed_schedule
                this.headerEntry.data.items[index].planned_schedule_percent = 100
                this.headerEntry.data.items[index].completed_schedule_percent = (completed_schedule/planned_schedule * 100).toFixed(2)
                this.headerEntry.data.items[index].incompleted_schedule_percent = (100 - this.headerEntry.data.items[index].completed_schedule_percent).toFixed(2)
                this.modals.edit.open = false
                this.headerEntry.options.changed = true
            },
            saveDataEntry(){
                if ( !this.headerEntry.data.contract_id ) {
                    this.$alertNotification("Please select a Supplier Contract", "danger");
                    return false;
                }
                if ( !this.headerEntry.data.maintenance_id ) {
                    this.$alertNotification("Please select a Maintenance Type", "danger");
                    return false;
                }
                if ( !this.headerEntry.data.month ) {
                    this.$alertNotification("Please select a Month", "danger");
                    return false;
                }
                if ( !this.headerEntry.data.year ) {
                    this.$alertNotification("Please select a Year", "danger");
                    return false;
                }
                if (this.headerEntry.options.loadings.button) return ;
                this.headerEntry.options.loadings.button = true
                this.headerEntry.options.loadings.table = true

                this.$store.dispatch("PAConservancyController/saveDataEntries", this.headerEntry.data)
                    .then(response => {
                        this.headerEntry.options.loadings.button = false
                        this.headerEntry.options.changed = false
                        this.headerEntry.options.loadings.table = false
                    })
                    .catch(err => {
                        this.headerEntry.options.loadings.button = false
                        this.headerEntry.options.loadings.table = false
                        if (err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "danger")
                        }

                    })
            }

        }
    }
</script>